import React from "react";
import styles from "./styles.module.css";
import { RiFileExcel2Line } from "react-icons/ri";

declare global {
    interface Navigator {
        msSaveOrOpenBlob?: (blob: any, defaultName?: string) => boolean
    }
}

class ExportExcel extends React.Component {
  render() {
    function exportTableToExcel(tableID: any, filename: any = '') {
      let downloadLink;
      let dataType = "application/vnd.ms-excel";
      let tableSelect: any = document.getElementById(tableID);
      let tableHTML = tableSelect.outerHTML.replace(/ /g, "%20");

      filename = filename ? filename + ".xls" : "RelatórioGeral.xls";
      downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        let blob = new Blob(["\ufeff", tableHTML], {
          type: dataType,
        });
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        downloadLink.href = "data:" + dataType + ", " + tableHTML;
        downloadLink.download = filename;
        downloadLink.click();
      }
    }
    return (
      <div className={styles.export}>
        <strong>Exportar: </strong>
        <RiFileExcel2Line
          title="Exportar para o Excel"
          color="green"
          size={30}
          onClick={() => exportTableToExcel("tableData")}
        />
      </div>
    );
  }
}

export default ExportExcel;
